module.exports = "/_next/static/images/RV-Dealers-Section-6e7311ef25c91e1877fda7ca3205c54c.png";